import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { IHierarchy } from 'src/app/interfaces/ihierarchy';
import { ISize } from 'src/app/interfaces/isize';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'quant-button',
  standalone: true,
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [CommonModule, TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'general',
    },
  ],
})
export class ButtonComponent {
  @Input() label: string = 'Button';
  @Input() disabled: boolean = false;
  @Input() hierarchy: IHierarchy = 'primary';
  @Input() size: ISize = 'lg';
  @Input() iconLeading: string = '';
  @Input() iconTrailing: string = '';
  @Input() badge: boolean = false;
  @Input() badgeIcon: string = '';

  @Output() onClick = new EventEmitter<void>();

  constructor(private translationService: TranslationService) {}

  ngOnInit() {
    this.translationService.loadScopedTranslation('general');
  }

  handleClick() {
    if (!this.disabled) {
      this.onClick.emit();
    }
  }
}
